module.exports = __webpack_public_path__ + "img/facebook.png.7dd25ac1.webp";